export default __webpack_public_path__ + "static/media/Schaltschrank_1_Geraet.3e6f2c80.png";